<template>
  <div class="innerBox">
    <h1>Master Data - Pekerja</h1>

    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox">
        <div class="col row">
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" v-on:keyup.enter="vue_universal_table.update++"  class="form-control" placeholder="Ketik teks" style="height: 38px;" v-model="filter.search">
          </div>
          <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    <vue-universal-table
      :api_url="'/api/v1/masterData/labourer'"
      :filter="filter"
      :special_buttons="vue_universal_table.special_buttons"
      :buttons="vue_universal_table.buttons"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      :sort_by="'id'"
      :sort_order="'DESC'"
      :process_data="vue_universal_table.process_data"
      moment_format="DD MMM YY hh:mm"
      @onBuatBaru="modal.add = true"
      @onEdit="editObj"
      @onDelete="deleteObj"
    ></vue-universal-table>

    <new-laborer
      v-if="modal.add"
      @closeModal="modal.add = false"
      @updateTable="updateTable"
    ></new-laborer>

    <edit-laborer
      v-if="modal.edit"
      :editObject="editObject"
      @closeModal="modal.edit = false"
      @updateTable="updateTable"
    ></edit-laborer>

  </div>
</template>

<script>
  import newLaborer from './children/newLaborer'
  import editLaborer from './children/editLaborer'

  export default {
    data () {
      return {
        mobile : this.isMobile(),
        modal : {
          add : false,
          edit : false,
        },
        editObject : null,
        filter : {
          search : ''
        },
        vue_universal_table : {
          special_buttons : ['buatBaru'],
          buttons : [
            {
              title : "Edit",
              class : "btn-outline-primary fas fa-edit",
            },
            {
              title : "Delete",
              variable : "id",
              class : "btn-outline-danger fas fa-times",
            }
          ],
          fields : [
            {
              title : "ID",
              variable : "id"
            },
            {
              title : "Nama Pekerja",
              variable : "name"
            },
            {
              title : "Tipe Pekerja",
              variable : "laborer_type_names"
            },
            {
              title : "Gaji Bulanan",
              variable : "gaji_bulanan"
            },
            {
              title : "Bonus Mingguan",
              variable : "bonus_mingguan"
            },
            {
              title : "Gaji Harian",
              variable : "gaji_harian"
            },
            {
              title : "Bergabung Pada",
              variable : "join_date"
            },
            {
              title : "Dibuat Pada",
              variable : "created_at"
            }
          ],
          update : 0,
          process_data : `
            for (var i in data) {
              data[i].laborer_type_names = data[i].labour_type.map(x=>x.labourer.name).join(", ");
              data[i].gaji_bulanan = 'Rp. ' + this.numberWithCommas(data[i].monthly_base_salary);
              data[i].bonus_mingguan = 'Rp. ' + this.numberWithCommas(data[i].weekly_bonus);
              data[i].gaji_harian = 'Rp. ' + this.numberWithCommas(data[i].daily_base_salary);
            }
          `,
        }
      }
    },
    components : {
      newLaborer,
      editLaborer,
    },
    mounted () {

    },
    methods : {
      editObj(obj){
        this.editObject = JSON.parse(obj);
        this.modal.edit = true;
      },
      deleteObj(id){
        this.$http.delete(`/api/v1/masterData/labourer/${id}`)
        .then((resp)=>{
          this.$store.dispatch('triggerAlert', [true, ['Pekerja telah berhasil dihapus']])
          this.vue_universal_table.update++;
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      updateTable(){
        this.loadFilterOptions('laborer');
        this.vue_universal_table.update++
      },
    }
  }
</script>

<style scoped>
  .pt20{
    padding-top : 20px;
  }
</style>